export var ComponentValuesType;
(function (ComponentValuesType) {
    ComponentValuesType["Code"] = "code";
    ComponentValuesType["Link"] = "link";
    ComponentValuesType["Image"] = "image";
    ComponentValuesType["PDF"] = "pdf";
    ComponentValuesType["Question"] = "question";
    ComponentValuesType["RichText"] = "text";
    ComponentValuesType["SectionTitle"] = "sectionTitle";
    ComponentValuesType["UnsplashImage"] = "unsplashImage";
    ComponentValuesType["Video"] = "video";
    ComponentValuesType["VirtualLab"] = "virtualLab";
    /** This type is deprecated, only here for backwards compatibility */
    ComponentValuesType["ScreenCapture"] = "screencapture";
    /** This type is deprecated, only here for backwards compatibility */
    ComponentValuesType["TalkingHead"] = "talkinghead";
})(ComponentValuesType || (ComponentValuesType = {}));
//# sourceMappingURL=CommonComponentValues.js.map